import { fetchAuthenticityToken } from "app/scripts/refresh_form_authenticity_token"

export const isTransientNetworkFetchError = (error) => {
  if (!error) return false
  const err = error?.error ?? error
  if (typeof err === "object" && err?.name === "AbortError") return true
  if (err instanceof TypeError) {
    const msg = (err.message || "").toLowerCase()
    return msg.includes("load failed") || msg.includes("failed to fetch") || msg.includes("network")
  }
  if (typeof err === "string") {
    const msg = err.toLowerCase()
    return msg.includes("load failed") || msg.includes("failed to fetch") || msg.includes("network")
  }
  return false
}

export async function xhrPromise(providedUrl, options) {
  let url = providedUrl

  options.headers = Object.assign(
    {
      "x-requested-with": "XMLHttpRequest",
    },
    options.headers
  )

  if (!options.method || options.method.toLowerCase() === "get") {
    let queryString = new URLSearchParams(options.data).toString()
    if (queryString) url = `${url}?${queryString}`
  } else {
    await updateOptions(options)
  }

  return new Promise((resolve, reject) => {
    fetch(url, options)
      .then(response => {
        if (!response.ok) {
          reject({
            response: response.json() || response.text(),
            status: response.status,
            error: response.statusText,
          })
        }

        return response
      })
      .then(async response => {
        const contentType = response.headers.get("Content-Type")
        const text = await response.text()

        if (/text\/javascript/.test(contentType)) {
          const validHost = ["ifttt.com", "web-rehearsal.ifttt.com", "ifttt.me", "acceptance.ifttt.com"].includes(
            new URL(response.url).hostname
          )
          if (["post", "put", "patch"].includes(options.method.toLowerCase()) && validHost) {
            eval(text)
          }
          return text
        } else if (/application\/json/.test(contentType)) {
          return text ? JSON.parse(text) : {}
        } else if (/text\/html/i.test(contentType)) {
          return text
        }
      })
      .then(resolve)
      .catch(error => {
        reject({
          response: "",
          status: "",
          error,
        })
      })
  })
}

export function logRejectedXHRPromise(response, status, error) {
  if (isTransientNetworkFetchError({ error })) {
    window.App.Utils?.logCustomDatadogAction?.("xhr_promise_network_error", {
      status: status || null,
    })
    if (window.App.allowDebugErrorMessages) {
      console.warn("xhr transient network error", response, status, error)
    }
    return
  }

  const context = { tags: { status }, extra: { response } }

  if (window.App?.Sentry?.captureException && window.App?.Sentry?.captureMessage) {
    if (error instanceof Error) {
      window.App.Sentry.captureException(error, context)
    } else if (typeof error === "string" && error.length > 0) {
      window.App.Sentry.captureMessage(`XHR Promise failed with error: ${error}`, context)
    } else {
      window.App.Sentry.captureMessage(`XHR Promise failed with status: ${status}`, context)
    }
  }

  if (window.App.allowDebugErrorMessages) {
    console.warn("catch", response, status, error)
  }
}

export function rejectedXHRPromiseLogger(callback = () => true) {
  return function ({ response, status, error }) {
    logRejectedXHRPromise(response, status, error)
    return callback({ response, status, error })
  }
}

async function updateOptions(options) {
  options.redirect = "error"

  options.headers = Object.assign(
    {
      Accept: options.headers.Accept || "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": await fetchAuthenticityToken(),
    },
    options.headers
  )

  if (options.data) {
    options.body = options.data
  } else if (typeof options.body !== "string") {
    options.body = JSON.stringify(options.body)
  }
}
